export interface DevicesAppWebComponentSchema {
  data: any;
  externalFilters: Array<any>;
}

export enum ColumnKeys {
  COMPANY = 'companyId',
  DEVICE_NAME = 'endpointId',
  RISK_SCORE = 'scoreBreakdown.finalScore',
  DEVICE_MISCONFIGURATIONS = 'misconfigurationIds',
  DEVICE_CVES = 'cveCount',
  DEVICE_TYPE = 'endpointType',
  OS = 'operatingSystem',
  REGION = 'region',
  STATUS = 'status',
  STATE = 'state',
  DEVICE_FQDN = 'fqdn',
  DEVICE_MACS = 'macs',
  DEVICE_TAGS = 'tags',
  WATCHLIST = 'watchlist',
  SELECT = 'select',
  DEVICE_IP = 'ip',
  RESOURCE_ID = 'resourceId',
  CLOUD_ACCOUNT = 'cloudAccount',
  REPOSITORY_NAME = 'imageMetadata.imageRepo',
  REGISTRY_HOST = 'imageMetadata.registryHost',
  CLUSTER_NAME = 'kspmMetadata.clusterName',
}

// WARNING: Changing the order may break existing Smart Views
export enum ColumnIndexes {
  COMPANY,
  DEVICE_NAME,
  RISK_SCORE,
  DEVICE_MISCONFIGURATIONS,
  DEVICE_CVES,
  DEVICE_TYPE,
  OS,
  STATUS,
  STATE,
  DEVICE_FQDN,
  DEVICE_MACS,
  DEVICE_TAGS,
  WATCHLIST,
  SELECT,
  DEVICE_IP,
  REGION,
  RESOURCE_ID,
  CLOUD_ACCOUNT,
  REPOSITORY_NAME,
  REGISTRY_HOST,
  CLUSTER_NAME,
}
